export const environment = {
  production: false,
  realTimeConsumptionRefresh: {
    interval: 60000, // milliseconds
    enabled: true,
  },
  urls: {
    frontend: process.env.REACT_APP_FRONTEND_HOST,
    backend: process.env.REACT_APP_BACKEND_HOST,
    grafana: process.env.REACT_APP_GRAFANA_SERVER_ROOT_URL,
    common: {
      login: () => `/token`,
      register: () => `/users/register`,
    },
    locations: {
      byUser: (userId = "me") => `/locations/user/${userId}`,
    },
    sections: {
      byLocation: (locationId) => `/locations/user/${locationId}`,
    },
  },
};
